import { render, staticRenderFns } from "./arrow-swap-horizontal.vue?vue&type=template&id=6fa4284c&"
import script from "./arrow-swap-horizontal.vue?vue&type=script&lang=js&"
export * from "./arrow-swap-horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fa4284c')) {
      api.createRecord('6fa4284c', component.options)
    } else {
      api.reload('6fa4284c', component.options)
    }
    module.hot.accept("./arrow-swap-horizontal.vue?vue&type=template&id=6fa4284c&", function () {
      api.rerender('6fa4284c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/arrow-swap-horizontal.vue"
export default component.exports